import { Controller } from "@hotwired/stimulus"
import { FetchRequest, get, post } from '@rails/request.js'

export default class extends Controller {
  static values = {
    searchUrl: String,
    selectUrl: String,
    formElement: String,
    formId: String,
  }
  static timeoutId = null

  connect() {

  }

  async search(event) {
    post('/globalsearch', {
      body: {
        search: document.getElementById("globalsearch").value
      },
      contentType: "application/json",
      headers: {},
      query: {},
      responseKind: "html"
    })


  }

  async link(event, type = "html", target = "content") {
    if (type == "html") {
      Turbo.visit(event.params.selectUrl, { frame: target })
      return;
    } else {
      const request = fetch(
        event.params.selectUrl,
        {
          headers: {
            Accept: "text/vnd.turbo-stream.html",
          }
        }
      )
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
    }
  }

  // async select(event) {
  //   // document.getElementById(this.formElementValue).value = event.params.objectid
  //   // document.getElementById(this.formIdValue).requestSubmit()
  //   console.log(event)
  //   const request = new FetchRequest(
  //     "post",
  //     this.selectUrlValue,
  //     {
  //       body: JSON.stringify({
  //         entity_id: event.params.objectid
  //       }),
  //       responseKind: "turbo-stream"
  //     }
  //   )
  //   const response = await request.perform()
  //   if (response.ok) {
  //     const body = await response.text
  //     Turbo.renderStreamMessage(body)
  //   }
  // }

  async select(event) {
    let json_data = {}
    json_data[`${event.params.model.toLowerCase()}_${event.params.association}`] = {
      resource_id: event.params.objectid,
      resource_type: event.params.objecttype
    }
    const request = new FetchRequest(
      "post",
      this.selectUrlValue,
      {
        body: JSON.stringify(json_data),
        responseKind: "turbo-stream"
      }
    )
    const response = await request.perform()
    if (response.ok) {
      const body = await response.text
      Turbo.renderStreamMessage(body)
    }
  }

  async getDetail(event) {
    const response = await get(event.params.detailUrl, { responseKind: "turbo-stream" })
    if (response.ok) {
      const html = await response.text
      Turbo.renderStreamMessage(html)
    } 
  }

  async sort(event) { 
    const request = new FetchRequest(
      "post",
      event.params.sortUrl,
      {
        responseKind: "turbo-stream"
      }
    )
    const response = await request.perform()
    if (response.ok) {
      const body = await response.text
      Turbo.renderStreamMessage(body)
    }
  }

  refresh(event) {
    //this.visit(this.urlParameters(event), { frame: "table"} )
    this.request(this.searchUrlValue)
  }

  keyup(event) {
    clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(
      this.request,
      300,
      this.searchUrlValue,
      event.params.hasOwnProperty("requestparams") ? event.params.requestparams : null
    )

  }

/*   fetch(url) {
    fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'text/vnd.turbo-stream.html'
        }
      }
    ).then (response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  } */

  async request(url, method, params = {}) {
    const request = new FetchRequest(
      "post",
      url,
      {
        body: JSON.stringify(Object.assign(
          {
          search: document.getElementById("searchfield").value
          },
          params
        )),
        responseKind: "turbo-stream"
      }
    )
    const response = await request.perform()
    if (response.ok) {
      const body = await response.text
      Turbo.renderStreamMessage(body)
    }
  }

  visit(url) {
    Turbo.visit(url, { frame: "table"} )
  }

}
